module.exports = __webpack_public_path__ + "img/plan-desarrollo.33f8f439.png";